<template>
  <div class="product-page">
    <!-- 页面标题条 -->
    <div class="page-hero">
      <div class="container">
        <h1>产品中心</h1>
        <p>精选优质产品，满足您的多样需求</p>
      </div>
    </div>

    <div class="container content">
      <!-- 搜索栏：按名称关键字搜索，回车即可搜索 -->
      <div class="search-bar">
        <el-input
          v-model="query.keyword"
          placeholder="输入产品名称搜索"
          clearable
          style="max-width: 360px"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-input>
      </div>

      <!-- 产品网格 -->
      <div v-loading="loading" class="product-grid">
        <router-link v-for="p in list" :key="p.id" :to="`/products/${p.id}`" class="product-card">
          <div class="product-cover">
            <img v-if="p.cover" :src="p.cover" :alt="p.name">
            <div v-else class="img-placeholder">暂无图片</div>
          </div>
          <div class="product-body">
            <h4 class="product-name">{{ p.name }}</h4>
            <p class="product-summary">{{ p.summary || '暂无简介' }}</p>
            <div class="product-price">{{ priceText(p.price) }}</div>
          </div>
        </router-link>
      </div>

      <el-empty v-if="!loading && list.length === 0" description="没有找到相关产品" />

      <!-- 分页：总数大于一页时才显示 -->
      <el-pagination
        v-if="total > query.size"
        class="pagination"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="query.size"
        :current-page="query.page"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { getProductList } from '../api'

export default {
  name: 'ProductList',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      // 查询条件：页码、每页条数、名称关键字
      query: { page: 1, size: 12, keyword: '' }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await getProductList(this.query)
        this.list = res.data.list
        this.total = res.data.total
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.query.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchList()
    },
    priceText(price) {
      if (price === null || price === undefined) return '面议'
      return '￥' + Number(price).toFixed(2)
    }
  }
}
</script>

<style scoped>
.content { padding: 32px 0 60px; }

.search-bar { margin-bottom: 24px; }

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 24px;
  min-height: 80px;
}
.product-card {
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.25s;
}
.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}
.product-cover { height: 190px; background: #f5f7fa; }
.product-cover img { width: 100%; height: 100%; object-fit: cover; }
.product-body { padding: 16px 18px 20px; }
.product-name {
  margin: 0 0 8px;
  font-size: 17px;
  color: #1f2d3d;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.product-summary {
  margin: 0 0 12px;
  height: 42px;
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
  overflow: hidden;
}
.product-price { color: #f56c6c; font-size: 18px; font-weight: 600; }

.pagination { margin-top: 28px; text-align: center; }
</style>
